import is from './_helpers/is';
/**
 * 判断某个对象是否是数组类型
 * @param  {any}  obj 需要判断的Object
 * @return {boolean}      对象是否是数组类型
 */
export default function isArray(obj) {
    return is('Array', obj);
}
//# sourceMappingURL=is-array.js.map